import {
  StyleSheet, Text, View,
  FlatList, Alert,
  Linking
} from 'react-native'
import React, { useEffect } from 'react'
import CoupanItemView from './widgets/CoupanItemView';
import Header from './widgets/Header';
import { RouteProp, useNavigation, useRoute } from "@react-navigation/native";
import { RootStackParamList } from '../../Types/uitypes';
import { useCoupanStore } from './CoupanScreenStore';
import { navStack } from '../../Types/uitypes';

type NavigationProp = RouteProp<
  RootStackParamList,
  "CoupansScreen"
>;

export default function CoupansScreen() {

  const route = useRoute<NavigationProp>();
  const { user } = route.params;
  const navigation = useNavigation<navStack>();

  const { loadItems, coupans, logout,
    handleDeleteAccount, helpUrl,
    hideActivityIndicator,
    toggleActivityIndicator,
    handleBuy
  } = useCoupanStore();

  useEffect(() => {
    loadItems();
  }, [loadItems]);


  function handleLogout() {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (confirmed) {
      toggleActivityIndicator();
      logout(() => {
        navigation.navigate("LoginScreen");
      });
    }
  }


  async function handleDelete() {
    const confirmed = window.confirm(
      "This action is permanent. Delete your account?"
    );
    if (confirmed) {
      toggleActivityIndicator();
      handleDeleteAccount(() => {
        navigation.navigate("LoginScreen");
      });
    }
  }

  async function hanldeHelpUrl() {
    await Linking.openURL(helpUrl);
  }

  function handleMenuItemClick(option: string) {
    switch (option) {
      case 'logout':
        handleLogout();
        break;

      case 'deleteAccount':
        handleDelete();
        break;

      case 'updatePassword':
        navigation.navigate("UpdatePasswordScreen");
        break;

      case 'help':
        hanldeHelpUrl();
        break;

      default:
        console.log('Unknown option:', option);
    }
  }



  return (
    <View>
      <FlatList
        data={coupans}
        keyExtractor={(item) => item.id.toString()}
        renderItem={({ item }) => <CoupanItemView item={item} onItemPress={() => handleBuy(item)} />}
        contentContainerStyle={styles.container}
        ListHeaderComponent={() => <Header
          handleItemClick={handleMenuItemClick}
          name={user.name}
          isLoading={hideActivityIndicator}
        />}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: { padding: 16, gap: 10 }
});